module.exports = __webpack_public_path__ + "static/media/icon-user.36742ce1.jpg";